<template lang="pug">
v-checkbox.dv-checkbox(
  v-bind="extendAttrs"
  v-on="extendListeners"
  :offIcon="offIcon"
  :onIcon="onIcon"
  :indeterminate-icon="indeterminateIcon"
)
  template(
    v-for="(_, name) in $scopedSlots"
    v-slot:[name]="data"
  )
    slot(:name="name" v-bind="data")
  template(
    v-for="(_, name) in $slots"
    :slot="name"
  )
    slot(:name="name")
  template(#label)
    slot(name="label" v-bind="{ label, description }")
      .d-flex.flex-column.gap-4.gc-1.ui-neutral--text(v-if="label || description")
        slot(name="name" v-bind="{ name: label }")
          p.ui-body-1(v-if="label") {{ label }}
        slot(name="description" v-bind="{ description }")
          p.ui-body-2.opacity-60(v-if="description") {{ description }}
</template>

<script>
import { VCheckbox } from 'vuetify/lib';

export default {
  components:  {
    VCheckbox,
  },
  model: {
    prop: 'inputValue',
    event: 'input',
  },
  props: {
    inputValue: {
      type: [Array, String, Number, Boolean],
      default: undefined,
    },
    value: {
      type: [Array, Number, String, Boolean],
      default: undefined,
    },
    label: {
      type: String,
      default: null,
    },
    description: {
      type: String,
      default: null,
    },
    offIcon: {
      type: String,
      default: '$ui-checkbox-off',
    },
    onIcon: {
      type: String,
      default: '$ui-checkbox-on',
    },
    indeterminateIcon: {
      type: String,
      default: '$ui-checkbox-minus',
    },
  },
  data() {
    return {};
  },
  computed: {
    extendAttrs() {
      const {
        label,
        value,
        inputValue,
      } = this;
      return {
        label,
        value,
        inputValue,
        ripple: false,
        trueValue: true,
        falseValue: false,
        ...this.$attrs,
      };
    },
    extendListeners() {
      return {
        ...this.$listeners,
        change: (val) => {
          this.$emit('input', val);
        },
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.dv-checkbox {
  margin-top: 0px;
  padding-top: 0px;
  align-items: start;
  &::v-deep .v-input__slot {
    align-items: start;
    gap: 12px;
    & > .v-input--selection-controls__input {
      margin-right: 0px;
      width: 20px;
      height: 20px;

      .v-icon__component {
        width: 20px;
        height: 20px;
      }
      & input {
        position: absolute;
        opacity: 0;
        width: 100%;
        height: 100%;
        cursor: pointer;
        user-select: none;
      }
    }
  }
  &.v-input--is-disabled {
    opacity: 0.4 !important;
  }
}
</style>
